// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { NetworkReviewFieldsets as ReviewFieldsets } from './SearchForm';
import { networkSearch } from 'api/content/search';
import SyndicationCopy from './NetworkSearchCopy';

const label = 'Network Reviews';
const NetworkReviewSearch = (props: *) => {
  const { hideCopy, ...rest } = props;

  return (
    <SearchView
      label={label}
      primaryFieldsets={ReviewFieldsets.primaryFieldsets}
      extraFieldsets={ReviewFieldsets.extraFieldsets}
      method={networkSearch}
      copy={hideCopy ? null : <SyndicationCopy />}
      {...rest}
    />
  );
};

NetworkReviewSearch.label = label;

export default NetworkReviewSearch;



// WEBPACK FOOTER //
// ./src/containers/search/NetworkReviews.js